// PopUp всплывающие сообщения
const AlertPlugin = {
    install( app, options = {} ) {
        // Глобальный метод для Vue-компонентов
        app.config.globalProperties.$alert = {
            success( message, duration = 3000 ) {
                showAlert( message, 'success', duration );
            },
            error( message, duration = 3000 ) {
                showAlert( message, 'error', duration );
            },
            info( message, duration = 3000 ) {
                showAlert( message, 'info', duration );
            },
            warning( message, duration = 3000 ) {
                showAlert( message, 'warning', duration );
            }
        };

        // Делаем доступным в inject/provide
        app.provide( 'alert', app.config.globalProperties.$alert );
    }
};

// Создаём элемент и показываем сообщение
function showAlert( message, type, duration ) {
    const alert = document.createElement('div');
    alert.className = `vue-alert vue-alert-${type}`;
    alert.innerHTML =
    `<div class="vue-alert-content">
        <span class="vue-alert-message">${message}</span>
        <button class="vue-alert-close" onclick="this.parentNode.parentNode.remove()">×</button>
    </div>`;

    document.body.appendChild(alert);

    setTimeout(() => {
        alert.remove();
    }, duration);
}

export default AlertPlugin;
